import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const networkComputeFieldPack: FieldPack = {
  id: 'network-compute',
  name: 'Compute Properties',
  description: 'EC2, Lambda, ECS/EKS instance-level fields',
  version: '1.0.0',
  dependencies: ['network-base'],
  fields: [
    {
      id: 'instanceType',
      label: 'Instance Type',
      type: FieldType.TEXT,
      tags: ['compute'],
      priority: 80,
      sensitivity: 'internal',
    },
    {
      id: 'ami',
      label: 'AMI',
      type: FieldType.TEXT,
      tags: ['compute'],
      priority: 75,
      sensitivity: 'internal',
    },
    {
      id: 'state',
      label: 'State',
      type: FieldType.SELECT,
      tags: ['compute', 'status'],
      priority: 90,
      options: [
        { value: 'running', label: 'Running' },
        { value: 'stopped', label: 'Stopped' },
        { value: 'terminated', label: 'Terminated' },
        { value: 'pending', label: 'Pending' },
      ],
      sensitivity: 'public',
    },
    {
      id: 'publicIp',
      label: 'Public IP',
      type: FieldType.TEXT,
      tags: ['compute', 'networking'],
      priority: 70,
      sensitivity: 'hr_restricted',
    },
    {
      id: 'privateIp',
      label: 'Private IP',
      type: FieldType.TEXT,
      tags: ['compute', 'networking'],
      priority: 65,
      sensitivity: 'internal',
    },
    {
      id: 'platform',
      label: 'Platform',
      type: FieldType.SELECT,
      tags: ['compute'],
      priority: 60,
      options: [
        { value: 'linux', label: 'Linux' },
        { value: 'windows', label: 'Windows' },
      ],
      sensitivity: 'public',
    },
    {
      id: 'runtime',
      label: 'Runtime',
      type: FieldType.TEXT,
      tags: ['compute'],
      priority: 55,
      sensitivity: 'public',
    },
    {
      id: 'memorySize',
      label: 'Memory (MB)',
      type: FieldType.NUMBER,
      tags: ['compute'],
      priority: 50,
      sensitivity: 'public',
    },
  ],
};
